import { render, staticRenderFns } from "./SalesListDetail.vue?vue&type=template&id=494ed5b4&scoped=true"
import script from "./SalesListDetail.vue?vue&type=script&lang=js"
export * from "./SalesListDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesListDetail.vue?vue&type=style&index=0&id=494ed5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ed5b4",
  null
  
)

export default component.exports